<div class="welcome__screen__figure col-xl-6 col-lg-6 col-md-6 col-sm-6">
</div>
<p><span translate>Begin paragraph1</span> <br />
    <span translate>Begin paragraph2</span>
</p>
<button routerLink="/creation" type="button" class="button button--purple button--big" [disabled]="loader"><span
        *ngIf="loader"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span translate>Loading</span></span><span *ngIf="!loader" translate>Begin button</span></button>